import { env } from '@/env';

export function browserStorageNamespacedKey(key: string): string {
  return `${env.browserStorageNamespace}-${key}`;
}

export function browserStorageSetItem(key: string, val: string): void {
  localStorage.setItem(browserStorageNamespacedKey(key), val);
}

export function browserStorageGetItem(key: string): string | null {
  return localStorage.getItem(browserStorageNamespacedKey(key));
}

export function browserStorageRemoveItem(key: string): void {
  return localStorage.removeItem(browserStorageNamespacedKey(key));
}

export function browserStorageSetSessionItem(key: string, val: string): void {
  sessionStorage.setItem(browserStorageNamespacedKey(key), val);
}

export function browserStorageGetSessionItem(key: string): string | null {
  return sessionStorage.getItem(browserStorageNamespacedKey(key));
}

export function browserStorageRemoveSessionItem(key: string): void {
  return sessionStorage.removeItem(browserStorageNamespacedKey(key));
}

export function getChannelAutoPublishDefault(postEditorType: string): boolean {
  const key = `autoPublishDefault-${postEditorType}`;
  return browserStorageGetItem(key) === 'true';
}

export function setChannelAutoPublishDefault(postEditorType: string, isAutoPublish: boolean): void {
  const key = `autoPublishDefault-${postEditorType}`;
  browserStorageSetItem(key, String(isAutoPublish));
}
